import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { BISTRO_INFO, BISTRO_TEL } from "@/lib/bistroInfo";

export default function Footer({ horaires }) {
  return (
    <footer className="bg-[#0A0A0A] text-white/80" data-testid="site-footer">
      <div className="bistro-divider" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <img
            src="/images/logo.png"
            alt="Le Bistrot de la Neuve"
            width="220"
            height="56"
            className="h-12 md:h-14 w-auto object-contain mb-4"
          />
          <p className="text-sm md:text-base leading-relaxed text-white/65 max-w-[20rem]">
            Brasserie, bar et restaurant au cœur de Viriat. Une cuisine généreuse, faite maison, à partager entre collègues, en famille ou entre amis.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-xl text-white mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0 text-[#A61C24]" />
              <span>
                Zone d'Activités de La Neuve<br />
                44 Rue du Plateau, 01440 Viriat
              </span>
            </li>
            <li className="flex gap-3"><Phone size={16} className="mt-0.5 shrink-0 text-[#A61C24]" /><a href={`tel:${BISTRO_TEL}`} className="hover:text-white">{BISTRO_INFO.telephone}</a></li>
            <li className="flex gap-3"><Mail size={16} className="mt-0.5 shrink-0 text-[#A61C24]" /><a href={`mailto:${BISTRO_INFO.email}`} className="hover:text-white">{BISTRO_INFO.email}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-xl text-white mb-4">Horaires</h4>
          <ul className="space-y-1.5 text-sm">
            {(horaires || []).map((h) => (
              <li key={h.id} className="flex justify-between gap-4">
                <span className="capitalize text-white/60">{h.jour}</span>
                <span className="text-right text-white/90">
                  {h.ferme ? "Fermé" : (
                    <>
                      {h.midi_ouverture && <span>{h.midi_ouverture}–{h.midi_fermeture}</span>}
                      {h.soir_ouverture && <span> · {h.soir_ouverture}–{h.soir_fermeture}</span>}
                    </>
                  )}
                </span>
              </li>
            ))}
          </ul>
          <p className="mt-3 text-[11px] leading-relaxed text-white/55 italic">
            Service restauration&nbsp;: 12h&ndash;14h &amp; 19h&ndash;22h. Bar ouvert en continu.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 grid grid-cols-1 md:grid-cols-3 items-center gap-3 text-xs text-white/40">
          <span className="text-center md:text-left" data-testid="footer-copyright">
            © 2026 Le Bistrot de la Neuve. Tous droits réservés.
          </span>
          <div className="flex items-center justify-center gap-4">
            <Link to="/politique-confidentialite" className="hover:text-white/70" data-testid="footer-privacy">
              Politique de confidentialité
            </Link>
            <span className="text-white/20">·</span>
            <Link to="/mentions-legales" className="hover:text-white/70" data-testid="footer-legal">
              Mentions légales
            </Link>
          </div>
          <span className="text-center md:text-right" data-testid="footer-credit">
            Site conçu et réalisé par{" "}
            <a
              href="https://axeris-labs.fr"
              target="_blank"
              rel="noreferrer"
              className="text-white/70 hover:text-white underline underline-offset-2"
            >
              Axeris Labs
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
